import React from 'react';
import './Loader.scss';
import { IMAGES_PATH } from 'constants/assets';
import { formatText } from 'core/i18n';
import { LOADER_ALT_TEXT, LOADER_IMAGE } from './constants';

export const Loader = () => {
    return (
        <div className="center-loader">
            <img src={`${IMAGES_PATH}/${LOADER_IMAGE}`} alt={LOADER_ALT_TEXT} />
            <div>{formatText('videoselfie-loadingCapturer')}</div>
        </div>
    );
};
